import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import FilterIcon from '@mui/icons-material/esm/FilterList';
import ExpandMore from '@mui/icons-material/esm/ExpandMore';
import ExpandLess from '@mui/icons-material/esm/ExpandLess';

export interface FilterPanelProps {
  title?: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
}

export default function FilterPanel({
  title = 'Filters',
  children,
  defaultExpanded = true,
}: FilterPanelProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          mb: expanded ? 2 : 0,
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <FilterIcon sx={{ mr: 1 }} />
          <Typography variant="h6" fontWeight="bold">
            {title}
          </Typography>
        </Box>
        <IconButton size="small">
          {expanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>

      <Collapse in={expanded}>{children}</Collapse>
    </Paper>
  );
}
